(function () {
    "use strict";
    var directivesModule = angular.module('appDirectives', []);

    directivesModule.directive('messageBox', [function () {
        return {
            restrict: 'E',
            replace: true,
            template: require('../Templates/message.html').default,
            scope: {
                message: "=",
                state: "@"
            }
        };
    }]);

    directivesModule.directive('onFinishRender', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope) {
                if (scope.$last === true) {
                    $timeout(function () {
                        scope.$emit('ngRepeatFinished');
                    });
                }
            }
        };
    }]);

    directivesModule.directive('bmEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.bmEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    });

    directivesModule.directive('dlcDocumenttype', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            replace: true,
            template: require('../Templates/documentType.html').default,
            scope: {
                documentType: '=type',
                groupBy: '@',
                title: '=',
                transTitle: '=',
                transVersion: '=',
                transReleaseDate: '=',
                transEmulation: '=',
                transDescription: '=',
                transDownload: '=',
                transOpen: '=',
                transClose: '=',
                transSortBy: '=',
                transDateFormat: '=',
                transShowAll: '=',
                transShowLatest: '=',
                system: '@',
                descriptionIcon: '=',
                tooltipIcon: '='
            },
            controller: ['$scope', function ($scope) {
                var selected = $scope.$parent.selected,
                    documentConcordance = $scope.$parent.documentConcordance,
                    structuredDocuments = $scope.$parent.structuredDocuments,
                    cache = {},
                    showAll = {},
                    showMore = {},
                    refreshTooltipIcons = function () {
                        $timeout(function () {
                            jQuery('.description-icon > .tooltip-icon').tooltip({
                                position:"bottom right",
                                offset:[-8, -255],
                                relative:true,
                                predelay:"300",
                                effect:"slide"
                            });
                        }, 100);
                    };

                $scope.selected = selected;
                $scope.documentConcordance = documentConcordance;
                $scope.structuredDocuments = structuredDocuments;

                $scope.toggleShowAll = function (documentType, $event) {
                    showAll[documentType] = !showAll[documentType];
                    refreshTooltipIcons();
                    $event.stopPropagation();
                };
                $scope.hasShowAll = function (documentType) {
                    return !!showAll[documentType];
                };
                $scope.toggleShowMore = function (type) {
                    showMore[type] = !showMore[type];
                };
                $scope.hasShowMore = function (type) {
                    return !!showMore[type];
                };
                $scope.getLimit = function (documentType, type) {
                    type = type || 'not needed here';
                    if (showAll[documentType] || showMore[type]) {
                        return undefined;
                    }
                    return 1;
                };

                $scope.orderVersionNumbers = function (v1, v2) {
                    var val1 = String(v1.value),
                        val2 = String(v2.value);
                    if (val1.search(/[a-zA-Z]/) !== -1) {
                        return val1.localeCompare(val2);
                    }
                    var v1Arr = val1.split(/[-\._,]/),
                        v2Arr = val2.split(/[-\._,]/),
                        res = 0;
                    for (var i = 0; i < v1Arr.length; i++) {
                        res = (+v1Arr[i]) - (+v2Arr[i]);
                        if (res === 0) {
                            continue;
                        }
                        return res > 0 ? -1 : 1;
                    }
                    return 0;
                };

                $scope.refreshTooltips = refreshTooltipIcons;

                $scope.showNgDialog = $scope.$parent.showNgDialog;

                $scope.getSorting = function (documents) {
                    if (documents.length > 0 && documents[0].sorting < 999999) {
                        return documents[0].sorting;
                    }
                    // hidden categories must not be displayed
                    return '999999; display: none;';
                };

                $scope.isReverseOrder = function (documentType) {
                    return documentType === 'drivers';
                }

                $scope.getDocuments = function (documentType) {
                    var language = selected[documentType].language.language || "English",
                        os, value;
                    if (! cache[documentType]) {
                        cache[documentType] = {};
                    }
                    if (! cache[documentType][language]) {
                        cache[documentType][language] = {};
                    }
                    switch (documentType) {
                        case 'drivers':
                        case 'applications':
                            os = selected[documentType].os[language] || "Windows 10";
                            if (!cache[documentType][language][os]) {
                                cache[documentType][language][os] = '';
                            }
                            value = structuredDocuments[documentType][language][os];
                            if (cache[documentType][language][os] !== value) {
                                refreshTooltipIcons();
                                cache[documentType][language][os] = value;
                            }
                            break;
                        default:
                            value = structuredDocuments[documentType][language];
                            if (cache[documentType][language] !== value) {
                                refreshTooltipIcons();
                                cache[documentType][language] = value;
                            }
                    }

                    return value;

                };

            }]
        };
    }]);

}());